import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/serviceSalesSaga";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";

const GroupCategory = () => {
  const dispatch = useDispatch();
  const isActive = useSelector(
    (state) => state.serviceSales.selectedFilters.group_categories === 2
  );

  return (
    <ToggleableButton
      isRadio
      isActive={isActive}
      title="service-sales-group-category"
      onClick={(data) => dispatch(actionCreators.updateGroupCategory(data))}
    />
  );
};

export default GroupCategory;
